import React from 'react';
import { makeStyles,useMediaQuery,useTheme } from '@material-ui/core';
import fly365 from '../../assets/images/fly365.png';
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles((theme) => ({
	loaderCont: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: 'white',
	},
	loader: {
		
		top: '30%',
		zIndex: 1000,
		position: 'absolute',
	},
}));

const HomeLoader = () => {
	const classes = useStyles();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));

	return (
		<div className={classes.loaderCont}>
			<div className={classes.loader} style={{left: matches?'5%':'35%'}}>
				{/* <CircularProgress color='secondary' />
                 */}
                 <img src='https://nitish.musafirbazar.com/static/logo.png'/>
			</div>
		</div>
	);
};

export default HomeLoader;
